import React, {useState} from 'react' // importing react + useState



export default function Myform(prop) {
  const [text,text2] = useState("")

  const textareaChange = (event)=>{
      text2(event.target.value)
  }

  const smallCase = () => {
    let smallcase = text.toLowerCase()
    text2(smallcase)
    prop.showalert("Converted to Lower Case!","success")
  }
  const upperCase = () => {
    let uppercase = text.toUpperCase()
    text2(uppercase)
    prop.showalert("Converted to Upper Case!","success")
  }
  const clear = () => {
    text2("")
    prop.showalert("Text Cleared!","success")

  }

  const copyToClipboard = () => {
    var getText = document.getElementById('textarea');
    // getText.select();
    // getText.setSelectionRange(0,9999);
    navigator.clipboard.writeText(getText.value);
    prop.showalert("Copied!","success")
  }

  const capitalize = () => {
    const getText =  document.getElementById('textarea');
    let lower = getText.value.toLowerCase();
    text2(lower.charAt(0).toUpperCase() + lower.slice(1));
    prop.showalert("Capitalized!","success")
  }

  const removeExtraSpaces = ()=> {
    let getText = document.getElementById('textarea');
    let removeSpaces = getText.value.replace(/\s+/g,' ').trim();
    text2(removeSpaces)

  }

  return (
    <>
    <div className='form-container'>
      <h1 className='form-heading'>Form</h1>
      <textarea name="textarea" id="textarea" cols="50" rows="10" value={text} onChange={textareaChange} placeholder='Message' className='textarea' style={prop.light}></textarea>
      <p style={{margin:'0 1rem'}}>{text?text.split(" ").length:0} words & {text.length} Characters</p>
      <button className='btn' onClick={smallCase} >Small Case</button>
      {/* <button className='btn' onClick={textareaClicked} >Text2</button> */}
      <button className='btn' onClick={upperCase}>Upper Case</button>
      <button className='btn' onClick={capitalize}>Capitalize</button>
      <button className='btn' onClick={clear}>Clear</button>
      <button className='btn' onClick={copyToClipboard}>Copy</button>
      <button className='btn' onClick={removeExtraSpaces}>Remove Extra Spaces</button>
      
      <div className='preview'>
        <h2>Preview</h2>
        <p>{text}</p>
      </div>
    </div>
    </>
  );
}












